import { LegalShell } from "./LegalShell";
import { env } from "@/lib/env";

export function LegalNotice() {
  return (
    <LegalShell title="Mentions légales">
      <h2>Éditeur</h2>
      <p>
        <strong>Super-Pari</strong><br />
        Adresse : à compléter, Dakar, Sénégal<br />
        Email : {env.VITE_SUPPORT_EMAIL}
      </p>

      <h2>Directeur de la publication</h2>
      <p>À compléter.</p>

      <h2>Hébergement</h2>
      <p>
        <strong>Vercel Inc.</strong> — 340 S Lemon Ave #4133, Walnut, CA 91789, USA<br />
        <strong>Supabase (base de données et auth)</strong> — Supabase Inc.
      </p>

      <h2>Conditions d'âge</h2>
      <p>L'utilisation du service est strictement réservée aux personnes majeures (18 ans révolus).</p>

      <h2>Propriété intellectuelle</h2>
      <p>L'ensemble des contenus, logos et marques de Super-Pari sont protégés. Toute reproduction non autorisée est interdite.</p>

      <h2>Crédits</h2>
      <p>Données sportives fournies par API-Football. Logos d'équipes : leurs ayants droit respectifs.</p>
    </LegalShell>
  );
}
